import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Page} from '../page';
import {PageRequest} from '../page-request';
import {SortOrder} from '../../sort/sort-order';
import {MatSelectChange} from '@angular/material/select';

@Component({
    selector: 'zah-mini-paginator',
    templateUrl: './mini-paginator.component.html',
    styleUrls: ['./mini-paginator.component.scss'],
    standalone: false
})
export class MiniPaginatorComponent {

  @Input()
  sortOrder: SortOrder;
  @Input()
  pageSize: number;
  @Input()
  currentPage: Page<any>;
  @Output()
  pageSizeChange: EventEmitter<number> = new EventEmitter<number>();
  @Output()
  sortOrderChange: EventEmitter<SortOrder> = new EventEmitter<SortOrder>();
  @Output()
  pageChange: EventEmitter<PageRequest<any>> = new EventEmitter<PageRequest<any>>();

  onSortOrderChange(sortOrder: SortOrder): void {
    this.sortOrder = sortOrder;
    this.sortOrderChange.emit(this.sortOrder);
  }

  onPageSizeChange(selectChange: MatSelectChange): void {
    this.pageSize = selectChange.value;
    this.pageSizeChange.emit(this.pageSize);
  }

  onPreviousClick(): void {
    this.pageChange.emit(PageRequest.previousPageRequest(this.currentPage));
  }

  onNextClick(): void {
    this.pageChange.emit(PageRequest.nextPageRequest(this.currentPage));
  }
}
